export function selectCurrentDeviceCfg(slice) {
  return slice.currentDevice;
}

export default selectCurrentDeviceCfg;
